import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Beatloader from '../../../../../../Common/Loaders/Beatloader';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchMoreAddressDetail } from '../../../../../../Redux/action/Organisation/Branch/BranchAction';

const EditMoreAddressess = ({ branch_id,
    token,
    user_id,
    b64id,
    refresh,
    show,
    handleClose,
    handleGetCity,
    refreshMoreAddress,

    loadState,
    loadCity,
    stateOptions,
    cityOptions,

    more_address_id

}) => {

    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (token && user_id && branch_id && more_address_id) {
            let customer_id = atob(b64id);
            if (customer_id) {
                dispatch(getBranchMoreAddressDetail(token, user_id, customer_id, branch_id, more_address_id));
            }
        }
    }, [more_address_id]);


    const {
        //addrrss view
        loadingBranchMoreAddressDetail,
        BranchMoreAddressDetailError,
        BranchMoreAddressDetail,
    } = useSelector(state => state?.BranchReducer);


    const initialValues = {
        customer_id: "",
        general_branch_id: "",
        type: "",
        name: "",
        address_line_one: "",
        address_line_two: "",
        address_line_three: "",
        city: "",
        postal_code: "",
        state: "",
        telephone: "",
        fax: "",
        email_address: ""
    };


    const formik = useFormik({
        initialValues: initialValues,
        // validationSchema: Yup.object({}),
        onSubmit: (values, { resetForm }) => {
            values.customer_id = atob(b64id);
            setDisableSubmit(true);

            try {
                const config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                // let url = `${adminMainUrl}/api/organization/general/branch/address/add`;
                let url = `${adminMainUrl}/api/organization/general/branch/address/update`;
                if (more_address_id) {
                    values.id = more_address_id;
                } else {
                    toast.error("More address Id not found");
                    return;
                }
                if (branch_id == 0) {
                    toast.error("Branch not found!");
                    return;
                } else {
                    values.general_branch_id = Number(branch_id);
                }

                axios.post(url, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableSubmit(false);
                            refreshMoreAddress();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error."
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    });
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (loadingBranchMoreAddressDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (BranchMoreAddressDetail) {
            if (BranchMoreAddressDetail?.state) {
                handleGetCity(Number(BranchMoreAddressDetail?.state));
            }
            formik.setFieldValue("general_branch_id", BranchMoreAddressDetail?.general_branch_id);
            formik.setFieldValue("type", BranchMoreAddressDetail?.type);
            formik.setFieldValue("name", BranchMoreAddressDetail?.name);
            formik.setFieldValue("address_line_one", BranchMoreAddressDetail?.address_line_one);
            formik.setFieldValue("address_line_two", BranchMoreAddressDetail?.address_line_two);
            formik.setFieldValue("address_line_three", BranchMoreAddressDetail?.address_line_three);
            formik.setFieldValue("city", Number(BranchMoreAddressDetail?.city));
            formik.setFieldValue("postal_code", BranchMoreAddressDetail?.postal_code);
            formik.setFieldValue("state", Number(BranchMoreAddressDetail?.state));
            formik.setFieldValue("telephone", BranchMoreAddressDetail?.telephone);
            formik.setFieldValue("fax", BranchMoreAddressDetail?.fax);
            formik.setFieldValue("email_address", BranchMoreAddressDetail?.email_address);
        }

    }, [loadingBranchMoreAddressDetail, BranchMoreAddressDetail]);

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

    return (
        <>

            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Address</Offcanvas.Title>
                </Offcanvas.Header>
                {
                    showLoader ?
                        <Beatloader />
                        :
                        <Offcanvas.Body>
                            <form onSubmit={formik.handleSubmit} className='row'>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="postal_code" className="form-label mb-0 ">
                                                Type
                                            </label>
                                        </div>
                                        <select
                                            type="text"
                                            className="form-control form-control-sm"
                                            id="name"
                                            name="type"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.type}
                                        >
                                            <option value="">-Select a type-</option>
                                            <option value="Delivery">Delivery</option>
                                            <option value="Factory">Factory</option>
                                            <option value="Pickup">Pickup</option>
                                            <option value="Warehouse">Warehouse</option>

                                        </select>

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="name" className="form-label mb-0 ">
                                                Name
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control form-control-sm"
                                            id="name"
                                            placeholder="Enter Name"
                                            name="name"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.name}
                                        />

                                    </div>
                                </div>
                                <div className=" col-12">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="address_line_one" className="form-label mb-0 ">
                                                Address
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            maxLength={250}
                                            className="form-control form-control-sm"
                                            id="address_line_one"
                                            placeholder="Address line 1"
                                            name="address_line_one"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.address_line_one}
                                        />

                                    </div>
                                </div>
                                <div className=" col-12">
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            maxLength={250}
                                            className="form-control form-control-sm"
                                            id="address_line_two"
                                            placeholder="Address line 2"
                                            name="address_line_two"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.address_line_two}
                                        />

                                    </div>
                                </div>
                                <div className=" col-12">
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            maxLength={250}
                                            className="form-control form-control-sm"
                                            id="address_line_three"
                                            placeholder="Address line 3"
                                            name="address_line_three"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.address_line_three}
                                        />

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="state" className="form-label mb-0 ">
                                                State
                                            </label>
                                        </div>
                                        <Select
                                            className='custom-selector'
                                            options={stateOptions}
                                            styles={customStyles}
                                            id="state"
                                            name="state"
                                            value={stateOptions.find(option => option.value === formik.values.state)}
                                            onChange={option => { formik.setFieldValue('state', option.value); handleGetCity(option.value); formik.setFieldValue('city', ''); }}
                                            onBlur={formik.handleBlur}
                                            isLoading={loadState}
                                        />

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="address_line_one" className="form-label mb-0 ">
                                                City
                                            </label>
                                        </div>
                                        <Select
                                            className='custom-selector'
                                            options={cityOptions}
                                            styles={customStyles}
                                            name="city"
                                            value={cityOptions.find(option => option.value === formik.values.city)}
                                            onChange={option => formik.setFieldValue('city', option.value)}
                                            onBlur={formik.handleBlur}
                                            isLoading={loadCity}
                                        />

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="postal_code" className="form-label mb-0 ">
                                                Postal Code
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            minLength={4}
                                            maxLength={6}
                                            className="form-control form-control-sm"
                                            id="postal_code"
                                            placeholder="Enter Postal Code"
                                            name="postal_code"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.postal_code}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                              }}
                    
                                        />

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="telephone" className="form-label mb-0 ">
                                                Telephone
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            minLength={8}
                                            maxLength={15}
                                            className="form-control form-control-sm"
                                            id="telephone"
                                            placeholder="Enter Telephone No."
                                            name="telephone"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.telephone}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="fax" className="form-label mb-0 ">
                                                Fax
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            minLength={8}
                                            maxLength={15}
                                            className="form-control form-control-sm"
                                            id="fax"
                                            placeholder="Enter FAX No."
                                            name="fax"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.fax}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />

                                    </div>
                                </div>
                                <div className=" col-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="email_address" className="form-label mb-0 ">
                                                Email Address
                                            </label>
                                        </div>
                                        <input
                                            type="email"
                                            maxLength={100}
                                            className="form-control form-control-sm"
                                            id="email_address"
                                            placeholder="Enter Email Address"
                                            name="email_address"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email_address}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex flex-wrap gap-2">
                                    </div>
                                    <button className="btn btn-sm btn-danger" type='submit' disabled={disableSubmit} >
                                        {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : `Update Address`}
                                    </button>
                                </div>
                            </form>
                        </Offcanvas.Body>
                }

            </Offcanvas>
        </>
    )
}

export default EditMoreAddressess